import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitContactForm = async (formData) => {
  const response = await axios.post(`${API_URL}/contact`, formData);
  return response.data;
};

export const getContacts = async () => {
  const response = await axios.get(`${API_URL}/contact`);
  return response.data;
};

export const getContactById = async (id) => {
  const response = await axios.get(`${API_URL}/contact/${id}`);
  return response.data;
};

export const markContactAsRead = async (id) => {
  const response = await axios.patch(`${API_URL}/contact/${id}/read`);
  return response.data;
};

export const deleteContact = async (id) => {
  const response = await axios.delete(`${API_URL}/contact/${id}`);
  return response.data;
};